import {useContext} from 'react'
import {OnlineStatusContext} from 'context'

export const useOnlineStatus = () => {
  return useContext(OnlineStatusContext)
}
